import React, { useEffect, useState } from 'react';
import Link from './Link';
import { useAuth } from "../../Auth/AuthContext";
import { listManagedEmployees } from "../../api/reviewsManaged";

const Sidebar = () => {
  const { user, signOut } = useAuth();
  const [isManager, setIsManager] = useState(false);

  useEffect(() => {
    let active = true;

    const checkManagerStatus = async () => {
      if (!user?.id) {
        if (active) setIsManager(false);
        return;
      }

      try {
        const res = await listManagedEmployees({ per_page: 1 });
        if (!active) return;
        const total = res?.meta?.total ?? res?.employees?.length ?? 0;
        setIsManager(total > 0);
      } catch {
        if (active) setIsManager(false);
      }
    };

    checkManagerStatus();
    return () => { active = false; };
  }, [user?.id]);
  const toggle = () => {
    // var btn = document.getElementById("header-btn");
    var sidebar = document.getElementById("sidebar");
    var main = document.getElementsByClassName("main");
    if (document.body.contains(sidebar) && main && sidebar.classList.contains("collapse-nav")) {
      sidebar.classList.remove("collapse-nav");

      // main.classList.remove("collapse-nav");
      for (var i = 0; i < main.length; i++) {
        main[i].classList.remove("collapse-nav")
      }
    } else {
      sidebar.classList.add("collapse-nav");
      for (var i = 0; i < main.length; i++) {
        main[i].classList.add("collapse-nav")
        
      }
    }
  };

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (e) {
      console.error('Logout failed', e);
    }
  };
  return (
    <>

      <aside id="sidebar" className="sidebar rounded-1 py-3 px-1 shadow">

        <div className="d-flex align-items-center justify-content-between mb-4 mt-2 px-3 ">
          <a href="/" className="logo d-flex align-items-center">
            <img src={ "assets/images/logos/logo.svg"} alt="" width="160" height="100" />
          </a>
          <i className="fa-solid fa-xmark toggle-sidebar-btn fa-2xl bx-x" onClick={() => toggle()}></i>

        </div>
        <ul className="sidebar-nav pt-3" id="sidebar-nav">
          <>
            <Link path={"/"} icon={"fa-solid fa-home text-light"} label={"Home"} sublinks={[]} />
            <Link path={"#"} icon={"fa-solid fa-user text-light"} label={"Employee Profile"} sublinks={[
              {
                url: "/employee-profile",
                label: "My Profile",
              },

            ]} />
            <Link path={"/past-appraisals"} icon={"fa-solid fa-users text-light"} label={"Past Appraisals"} sublinks={[
              {
                url: "/2022-review-cycle",
                label: "2023 Review Cycle"
              }
            ]} />

            <Link path={"/current-review-cycle"} icon={"fa-solid fa-trophy text-light"} label={"Current Review Cycle"} sublinks={[
              {
                url: "/performance-contract",
                label: "Performance Contract"
              },
              {
                url: "/goal-settings",
                label: "Goal Settings"
              },
              {
                url: "/idp/mine",
                label: "My IDP"
              },

              {
                url: "/reviews/mine",
                label: "My Review"
              },

              {
                url: "/three-sixty-review",
                label: "360 Review"
              },
              {
                url: "/three-sixty-review-feedback",
                label: "360 Review Feedback"
              }
            ]} />

            {isManager && (
              <Link path={"/current-review-cycle-teams"} icon={"fa-solid fa-users text-light"} label={"Team"} sublinks={[
                {
                  url: "/contracts",
                  label: "Employee Contracts"
                },
                {
                  url: "/idp/managed",
                  label: "Team IDPs"
                },
                {
                  url: "/reviews/team",
                  label: "Team Reviews"
                },
                {
                  url: "/employee-profiles",
                  label: "Team Profiles",
                }
              ]} />
            )}
            <Link path={"/dashboards"} icon={"fa-solid fa-chart-pie text-light"} label={"Dashboards"} sublinks={[
              {
                url: "/progress-dashboard",
                label: "Progress dashboard"
              },
              {
                url: "/performance-distribution",
                label: "Performance distribution"
              }
            ]} />

            <Link path={"/issue-logs"} icon={"fa-solid fa-list text-light"} label={"Issue Log"} sublinks={[]} />

            <Link path={"/help-support"} icon={"fa-solid fa-info text-light"} label={"Help & Support"} sublinks={[]} />

            <li>
              <button
                  className="btn btn-link text-start w-100"
                  onClick={handleLogout}
                  style={{ color: 'inherit', textDecoration: 'none' }}
              >
                <i className="fa-solid fa-right-from-bracket me-2"></i>
                Logout
              </button>
            </li>

          </>
        </ul>
      </aside>

    </>
  )
}
export default Sidebar;
